import OpportunitiesGrid from '@/modules/insights/OpportunitiesGrid';
import RisksList from '@/modules/insights/RisksList';
import { Box } from '@mui/material';

type InsightsProps = {
  investorId: number;
  lastLogin?: string | null;
  lastInviteDate?: string | null;
};

export default function Insights({
  investorId,
  lastLogin,
  lastInviteDate,
}: InsightsProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <RisksList
        investorId={investorId}
        lastLogin={lastLogin}
        lastInviteDate={lastInviteDate}
      />
      <OpportunitiesGrid
        investorId={investorId}
        size='flyout'
      />
    </Box>
  );
}
